import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, Select, message, InputNumber, Spin } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Cookies from "universal-cookie";

const { Option } = Select;

const CreaCasosJuridica = () => {
  const cookie = new Cookies();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const TEMAS_API = "https://contratosback.azurewebsites.net/api/v1/ObtenerTemas";
  const CREATE_API = "https://contratosback.azurewebsites.net/api/v1/CreaSolicitudJuridica";

  const [form] = Form.useForm();
  const [temas, setTemas] = useState([]);

  useEffect(() => {
    const fetchTemas = async () => {
      try {
        const response = await axios.get(TEMAS_API);
        setTemas(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error al obtener los temas:", error);
      }
    };
    fetchTemas();
  }, []);
  const getFechaColombiaISO = () => {
    const opciones = { timeZone: "America/Bogota", hour12: false };
    const fecha = new Date();

    const fechaColombia = new Intl.DateTimeFormat("sv-SE", {
      ...opciones,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).formatToParts(fecha);

    const getPart = (type) => fechaColombia.find((part) => part.type === type)?.value;

    // Construye un string con el formato deseado
    const year = getPart("year");
    const month = getPart("month");
    const day = getPart("day");
    const hour = getPart("hour");
    const minute = getPart("minute");
    const second = getPart("second");

    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
  };

  const handleSubmit = async (values) => {
    setLoading(true);

    const userId = cookie.get("id");

    // 🔴 VALIDACIÓN DE SESIÓN
    if (!userId || userId === "0" || userId === 0) {
      setLoading(false);

      Swal.fire({
        icon: "warning",
        title: "Sesión expirada",
        text: "Debe iniciar sesión nuevamente.",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        // Limpia cookies si deseas
        cookie.remove("id");
        window.location.href = "/login"; // ajusta la ruta si es necesario
      });

      return; // ⛔ Detiene la ejecución
    }

    const requestData = {
      IdTema: parseInt(values.idTema, 10),
      Titulo: values.titulo,
      Descripcion: values.descripcion,
      FechaCreacion: getFechaColombiaISO(),
      UsuarioCreacion: parseInt(userId, 10),
      IdEstado: 1,
      Nit: JSON.stringify(values.nit),
      Asociado: values.tieneTicket === "si" ? values.numeroCaso : 0,
    };

    try {
      const response = await axios.post(CREATE_API, requestData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.data) {
        const match = response.data.match(/\d+/);
        const caseId = match ? match[0] : null;

        if (!caseId) throw new Error("No se pudo extraer el ID del caso.");

        Swal.fire({
          icon: "success",
          title: "¡Caso Creado!",
          text: `El caso ha sido creado con éxito. ID: ${caseId}`,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          setOpen(false);
          window.location.href = `/AnexoJuridica/${caseId}`;
        });
      } else {
        throw new Error("Respuesta inválida de la API.");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo crear el caso. Intente nuevamente.",
        confirmButtonColor: "#d33",
      });
      console.error("Error al crear el caso:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-crear-caso">Crear un nuevo caso</Tooltip>}
      >
        <Button type="primary" onClick={() => setOpen(true)}>
          Nueva Solicitud
        </Button>
      </OverlayTrigger>

      <Modal
        title="CREACIÓN DE CASO"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={800}
        maskClosable={false}
        style={{ zIndex: 3000, marginTop: "-70px" }}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Tipo de Documento"
            name="idTema"
            rules={[{ required: true, message: "Seleccione un tema" }]}
          >
            <Select placeholder="Seleccione">
              {temas.map((tema) => (
                <Option key={tema.id} value={tema.id}>
                  {tema.descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Nombre del contratante o entidad"
            name="titulo"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="NIT sin Dígito de verificación"
            name="nit"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              controls={false}
              min={0}
              parser={(value) => value.replace(/\D/g, "")}
            />
          </Form.Item>

          <Form.Item
            label="Descripción"
            name="descripcion"
            rules={[{ required: true, message: "Campo obligatorio" }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item
            label="¿El caso tiene un ticket asociado?"
            name="tieneTicket"
            rules={[{ required: true, message: "Seleccione una opción" }]}
          >
            <Select placeholder="Seleccione">
              <Option value="si">Sí</Option>
              <Option value="no">No</Option>
            </Select>
          </Form.Item>

          <Form.Item shouldUpdate>
            {({ getFieldValue }) =>
              getFieldValue("tieneTicket") === "si" && (
                <Form.Item
                  label="Digite su número de caso asociado"
                  name="numeroCaso"
                  rules={[
                    { required: true, message: "Campo obligatorio" },
                    {
                      pattern: /^[0-9]+$/,
                      message:
                        "Solo se permite un número entero sin espacios ni caracteres especiales",
                    },
                  ]}
                >
                  <Input maxLength={15} />
                </Form.Item>
              )
            }
          </Form.Item>

          {/* Botones */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={() => setOpen(false)} disabled={loading}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {loading ? "Creando..." : "Crear Caso"}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CreaCasosJuridica;
